<template>
    <q-layout view="HhH lpR fff">
        <slot />
    </q-layout>
</template>
